import axios, { AxiosRequestConfig } from 'axios';
import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';

export const useGet = <T>(
  url: string,
  axiosCfg: AxiosRequestConfig = {},
  queryOptions: UseQueryOptions<UseGetResponse<T>, Error> = {}
): UseGetResult<T> => {
  const { queryKey = [], ...restQueryOptions } = queryOptions;
  const getResult = useQuery<UseGetResponse<T>, Error>({
    queryKey: [url, ...queryKey],

    queryFn: async () => {
      const axiosRes = await axios.request<UseGetResponse<T>>({ url, method: 'GET', ...axiosCfg });
      return axiosRes.data;
    },

    retry: false,
    ...restQueryOptions,
  });

  return getResult;
};

export type UseGetResponse<T> = {
  Data: T;
};

export type UseGetResult<T> = UseQueryResult<UseGetResponse<T>, Error>;
